import { render } from "./SelectProducts.vue?vue&type=template&id=229b046b"
import script from "./SelectProducts.vue?vue&type=script&lang=js"
export * from "./SelectProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__